// test1191
(1191 && 0);
